import { Link, useLocation } from "react-router-dom";
import { useSite } from "@/lib/content";
import { getLang, t } from "@/lib/i18n";
import { toLang } from "@/lib/routes";

export default function LangSwitcher({ className = "", testId = "lang-switcher", onNavigate }) {
  const { enLive, isAdmin } = useSite();
  const { pathname, hash } = useLocation();
  if (!enLive && !isAdmin) return null;
  const current = getLang();
  return (
    <nav aria-label={t("langSwitch.label")} className={className} data-testid={testId}>
      <ul className="inline-flex items-center rounded-full border border-line bg-white/70 p-0.5 text-xs font-semibold">
        {["tr", "en"].map((l) => (
          <li key={l}>
            <Link
              to={toLang(pathname, l, hash)}
              onClick={onNavigate}
              hrefLang={l}
              lang={l}
              aria-label={`${l.toUpperCase()} – ${t(`langSwitch.${l}`)}`}
              aria-current={current === l ? "true" : undefined}
              className={`inline-flex items-center justify-center min-h-[44px] min-w-[44px] px-2 rounded-full uppercase tracking-wider transition-colors ${current === l ? "bg-forest text-cream" : "text-ink-muted hover:text-forest"}`}
              data-testid={`${testId}-${l}`}
            >
              {l}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
